export const INITIAL_PARAMS: Record<string, string> = {
  page: "1",
  pageSize: "10",
  search: "",
  sort: "",
};

export const REQUESTED_FIELDS = [
  "isSellerMalgaCreated",
  "isSellerCercCreated",
].join(",");
